export { default } from './TaskStatBlock';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskStatBlock/index.js